import axios from "axios";
import { head } from "lodash";
import DateUtils from "../../../services/utils/DateUtils";

export default class TaskManagerServices {
  /*************************** CONSTANTS *************************** */
  dateUtils = new DateUtils();

  /**************************** FUNCTIONS ************************* */
  fetchCategories = (header) => {
    const url = `${process.env.REACT_APP_CUSTOMER_API_ENDPOINT}api/task/categories`;
    let result = [];
    axios
      .get(url, header)
      .then((res) => {
        if (res.status === 200) {
          res.data.data.map((item) => {
            result.push({
              value: item.id,
              label: item.name,
            });
          });
        } else {
          return;
        }
      })
      .catch((error) => {
        console.log("error ", this.props.t(error));
      });
    return result;
  };

  fetchTaskOwners = (header) => {
    const url = `${process.env.REACT_APP_CUSTOMER_API_ENDPOINT}api/analystAndAdminAnalyst.list`;
    let result = [];
    axios
      .post(url, {}, header)
      .then((res) => {
        if (res.status === 200) {
          const response = res.data.data;
          response.map((item) => {
            result.push({
              value: item.id,
              label: `${item.first_name} ${item.last_name}`,
            });
          });
        } else {
          return;
        }
      })
      .catch((error) => {
        console.log("error ", this.props.t(error));
      });
    return result;
  };

    async fetchRecurringTaskChildren(taskId, params = {}) {
        const response = await axios.get(`${process.env.REACT_APP_CUSTOMER_API_ENDPOINT}api/tasks/${taskId}/recurring-tasks`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        return response.data.data
    }
}
